const ImageEditIcon = () => {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M25.0001 13.3337H25.0167M18.3334 33.3337H11.6667C10.3407 33.3337 9.0689 32.8069 8.13121 31.8692C7.19353 30.9315 6.66675 29.6597 6.66675 28.3337L6.66675 11.667C6.66675 10.3409 7.19353 9.06914 8.13121 8.13146C9.0689 7.19378 10.3407 6.66699 11.6667 6.66699L28.3334 6.66699C29.6595 6.66699 30.9313 7.19378 31.8689 8.13146C32.8066 9.06914 33.3334 10.3409 33.3334 11.667V18.3337M6.66675 25.0003L13.3334 18.3337C14.8801 16.8453 16.7867 16.8453 18.3334 18.3337L23.3334 23.3337L25.0001 21.667C25.5167 21.1703 26.0734 20.8386 26.6451 20.6736M30.7001 26.017C31.0251 25.6919 31.411 25.4341 31.8356 25.2582C32.2603 25.0823 32.7154 24.9918 33.1751 24.9918C33.6347 24.9918 34.0899 25.0823 34.5145 25.2582C34.9392 25.4341 35.3251 25.6919 35.6501 26.017C35.9751 26.342 36.2329 26.7278 36.4088 27.1525C36.5847 27.5772 36.6753 28.0323 36.6753 28.492C36.6753 28.9516 36.5847 29.4068 36.4088 29.8314C36.2329 30.2561 35.9751 30.6419 35.6501 30.967L30.0001 36.667H25.0001V31.667L30.7001 26.017Z"
				stroke="var(--primary-text-color)"
				stroke-opacity="0.85"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export default ImageEditIcon;
